import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const Header = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`sticky top-0 z-40 w-full transition-all duration-300 ${
                scrolled
                    ? "bg-white/80 backdrop-blur-xl border-b border-[color:var(--brr-border)]"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16 sm:h-20">
                <Link
                    to="/"
                    data-testid="brand-logo"
                    className="flex flex-col leading-none"
                >
                    <span className="font-serif-display text-xl sm:text-2xl tracking-tight">
                        Better Rest{" "}
                        <span className="issue-tag">Report</span>
                    </span>
                    <span className="text-[10px] tracking-[0.28em] uppercase opacity-60 mt-1">
                        SleepComfortReport.com
                    </span>
                </Link>
                <nav className="hidden md:flex items-center gap-8 text-[12px] tracking-[0.22em] uppercase font-medium opacity-80">
                    <a
                        href="#report"
                        data-testid="nav-report"
                        className="hover:opacity-100 transition-opacity"
                    >
                        The Report
                    </a>
                    <a
                        href="#features"
                        data-testid="nav-features"
                        className="hover:opacity-100 transition-opacity"
                    >
                        Features
                    </a>
                    <Link
                        to="/contact"
                        data-testid="nav-contact"
                        className="hover:opacity-100 transition-opacity"
                    >
                        Contact
                    </Link>
                </nav>
                <a
                    href="#report"
                    data-testid="header-read-report-cta"
                    className="btn-ghost hidden sm:inline-flex"
                >
                    Read The Report
                </a>
            </div>
        </header>
    );
};
